import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { RoleName } from '../../types'
import { useCollapse } from '../../routes/collapse-context'
import { NewLoadingAndErrors } from '../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { useAuth } from '../../context/auth-context'
import { KudosReplyerManagementPage } from './KudosReplyerManagementPage'
import { KudosManagersManagementPage } from './KudosManagersManagementPage'
import { KudosHRManagementPage } from './KudosHRManagementPage'

const isOnlyReplyerOrReviewer = (userRoles: RoleName[]) => {
  const excludedRoles = [
    RoleName.ClusterManager,
    RoleName.NetworkManager,
    RoleName.CompanyManager,
    RoleName.BusinessPartner,
    RoleName.BuManager,
    RoleName.Hr,
  ]

  return !userRoles.some((name: RoleName) => excludedRoles.includes(name))
}

export const KudosManagementPage: FC = () => {
  const { user } = useAuth()
  const collapsed = useCollapse()
  const { t } = useTranslation()

  if (!user.roles || user.roles.length === 0) {
    return (
      <ContentContainer collapsed={collapsed}>
        <BackgroundBox r height="fullPage">
          <NewLoadingAndErrors
            isLoading={false}
            error={undefined}
            customErrorMessage={t('page.pageUnavailable.customMessage.KudosManagementPage')}
            hasNoData={false}
            showSpinner
            t={t}
          />
        </BackgroundBox>
      </ContentContainer>
    )
  }

  const isUserHr = user.roles.includes(RoleName.Hr)

  return isOnlyReplyerOrReviewer(user.roles) ? (
    <ContentContainer collapsed={collapsed}>
      <KudosReplyerManagementPage />
    </ContentContainer>
  ) : isUserHr ? (
    <ContentContainer collapsed={collapsed}>
      <KudosHRManagementPage />
    </ContentContainer>
  ) : (
    <ContentContainer collapsed={collapsed}>
      <KudosManagersManagementPage />
    </ContentContainer>
  )
}
